import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=1a7448f9"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7448f9')) {
      api.createRecord('1a7448f9', component.options)
    } else {
      api.reload('1a7448f9', component.options)
    }
    module.hot.accept("./EmailVerification.vue?vue&type=template&id=1a7448f9", function () {
      api.rerender('1a7448f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/OTPVerification/components/EmailVerification.vue"
export default component.exports